import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 87691 94553"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:1047.81}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g>
      <g id="_1974338611072">
        <path
          d="M76710 68144c5775 0 10457 4839 10457 10807 0 5969-4682 10808-10457 10808-541 0-1071-42-1590-124-1358 2616-4029 4394-7102 4394-4448 0-8054-3725-8054-8325 0-4003 2732-7344 6375-8143 660-5311 5051-9417 10371-9417zM10980 68144c-5775 0-10456 4839-10456 10807 0 5969 4681 10808 10456 10808 540 0 1071-42 1591-124 1357 2616 4027 4394 7101 4394 4448 0 8054-3725 8054-8325 0-4003-2733-7344-6375-8143-660-5311-5051-9417-10371-9417zM51154 26788c219 533 631 1004 1126 1287 1312 1760 2089 3941 2089 6305 0 5837-4733 10570-10569 10570-137 0-272-4-407-10-136 6-272 10-408 10-5836 0-10569-4733-10569-10570 0-2364 777-4545 2089-6305 495-283 907-754 1124-1287l79-220 63-259 36-273 1-242c-23-405-86-718-322-1182-1436-1138-2636-2581-3509-4233l-4-11c-174-329-335-669-482-1014l-7-19-58-133-65-161-31-84-36-91-43-116-19-50-76-212-24-70-33-101-28-86-59-189-30-95-19-64-36-123-26-92-36-133-19-74-47-185-13-46-37-157-13-56-43-197-11-56-32-156-11-65-30-160-14-76-26-165-12-81-22-154-7-44-29-217-3-29-20-178-7-68-15-168-7-65-15-207-2-18-12-204-1-37-11-231v-4l-6-195v-73l-3-213c0-7420 5818-13432 12996-13432 7177 0 12995 6012 12995 13432l-2 213-1 73-6 195v4l-9 231-3 37-12 204-2 18-15 207-7 65-15 168-7 68-20 178-5 29-27 217-7 44-21 154-13 81-28 165-12 76-30 160-11 65-32 156-12 56-43 197-12 56-38 157-12 46-47 185-19 74-36 133-26 92-36 123-19 64-29 95-59 189-29 86-34 101-23 70-76 212-19 50-43 116-36 91-31 84-65 161-56 133-9 19c-148 345-308 685-482 1014l-4 11c-875 1652-2073 3095-3510 4233-233 464-298 777-321 1182l1 242 36 273 63 259 77 220z"
          className="fill stroke1"
          style={{
            strokeWidth: 1047.81,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
